import React, { FC } from 'react'
import { Wrapper } from './style';
import Container from '../Container';

interface IAnimatedBackTitleProps {
  title: string;
};

const AnimatedBackTitle: FC<IAnimatedBackTitleProps> = ({ title }) => {
  return (
    <Wrapper>
      <Container>
        <h1>{title}</h1>
      </Container>
    </Wrapper>
  )
}

export default AnimatedBackTitle;
